import { Link } from "react-router-dom";
import { ArrowLeft, Mail, MessageCircle, LifeBuoy } from "lucide-react";
import Seo from "../components/Seo";
import SiteFooter from "../components/SiteFooter";

export default function ContactsPage() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-orange-50/40 to-slate-100">
      <Seo
        title="Contatti | quandomiserve.it"
        description="Contatti generali e assistenza utenti quandomiserve.it: info@quandomiserve.it e support@quandomiserve.it"
        canonical="/contatti"
      />

      <header className="max-w-4xl mx-auto px-4 sm:px-6 py-6 flex items-center gap-3">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-slate-600 hover:text-orange-600 transition-colors text-sm"
          data-testid="contacts-back-home"
        >
          <ArrowLeft className="w-4 h-4" />
          Torna alla home
        </Link>
      </header>

      <main className="max-w-4xl mx-auto px-4 sm:px-6 pb-16">
        <div className="mb-8">
          <h1 className="text-3xl sm:text-4xl font-bold text-slate-900">Contatti</h1>
          <p className="mt-2 text-slate-600 text-sm sm:text-base">
            Per qualsiasi informazione o richiesta di assistenza, puoi scriverci agli indirizzi qui sotto. Rispondiamo di norma entro 1&ndash;2 giorni lavorativi.
          </p>
        </div>

        <div className="grid gap-4 sm:grid-cols-2">
          {/* Contatti generali */}
          <a
            href="mailto:info@quandomiserve.it"
            className="group block bg-white border border-slate-200 hover:border-orange-300 hover:shadow-lg rounded-2xl p-6 transition-all"
            data-testid="contacts-info-card"
          >
            <div className="flex items-start gap-3">
              <div className="w-11 h-11 rounded-full bg-orange-100 flex items-center justify-center shrink-0 group-hover:bg-orange-200 transition-colors">
                <MessageCircle className="w-5 h-5 text-orange-600" />
              </div>
              <div>
                <p className="text-xs uppercase tracking-wider text-slate-500 font-semibold">Contatti generali</p>
                <p className="mt-1 text-lg font-semibold text-slate-900 group-hover:text-orange-600 transition-colors flex items-center gap-2">
                  <Mail className="w-4 h-4 shrink-0" />
                  info@quandomiserve.it
                </p>
                <p className="mt-2 text-sm text-slate-500">
                  Per informazioni commerciali, collaborazioni, richieste stampa e qualsiasi domanda non tecnica.
                </p>
              </div>
            </div>
          </a>

          {/* Assistenza utenti */}
          <a
            href="mailto:support@quandomiserve.it"
            className="group block bg-white border border-slate-200 hover:border-orange-300 hover:shadow-lg rounded-2xl p-6 transition-all"
            data-testid="contacts-support-card"
          >
            <div className="flex items-start gap-3">
              <div className="w-11 h-11 rounded-full bg-emerald-100 flex items-center justify-center shrink-0 group-hover:bg-emerald-200 transition-colors">
                <LifeBuoy className="w-5 h-5 text-emerald-600" />
              </div>
              <div>
                <p className="text-xs uppercase tracking-wider text-slate-500 font-semibold">Assistenza utenti</p>
                <p className="mt-1 text-lg font-semibold text-slate-900 group-hover:text-orange-600 transition-colors flex items-center gap-2">
                  <Mail className="w-4 h-4 shrink-0" />
                  support@quandomiserve.it
                </p>
                <p className="mt-2 text-sm text-slate-500">
                  Per assistenza tecnica, problemi di accesso, gestione account, prenotazioni e recensioni.
                </p>
              </div>
            </div>
          </a>
        </div>

        <div className="mt-10 p-4 rounded-xl border border-slate-200 bg-white/60 backdrop-blur-sm text-sm text-slate-600">
          <p>
            <strong>Titolare del trattamento:</strong> CMP ELETTROMECCANICA SRL &mdash; P.IVA 04565850163
          </p>
          <p className="mt-1">
            Sede legale: Via Isonzo n. 2A, 24040 Comun Nuovo (BG) &middot; Sede operativa: Via C. Colombo 45/46, 24050 Grassobbio (BG)
          </p>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}
